import React, { useState } from "react";
import Demande from "./Demande";
import Questionnaire from "./Questionnaire";
import RendezVous from "./RendezVous";

function MyalfaLink() {
  const [email, setEmail] = useState("");
  const [mdp, setMdp] = useState("");
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [error, setError] = useState("");

  const [clientSelected, setClientSelected] = useState(null);
  const [sectionSelected, setSectionSelected] = useState("");

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    setClients([]);
    setClientSelected(null);
    setSectionSelected("");

    try {
      const response = await fetch(
        "https://backend-myalfa.vercel.app/api/clients/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, mdp }),
        }
      );

      if (!response.ok) throw new Error();
      const data = await response.json();
      setClients(data);
    } catch {
      setError("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 px-6 py-6">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* TITRE */}
        <h1 className="text-2xl font-semibold text-gray-800">MyAlfa Link</h1>

        {/* FORMULAIRE */}
        <div className="bg-white border rounded-lg p-4 space-y-3">
          <h2 className="text-sm font-medium text-gray-600">Connexion</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="col-span-1 md:col-span-1 px-3 py-2 border rounded-md focus:ring-1 focus:ring-blue-500"
            />

            <input
              type="password"
              placeholder="Mot de passe"
              value={mdp}
              onChange={(e) => setMdp(e.target.value)}
              className="col-span-1 md:col-span-1 px-3 py-2 border rounded-md focus:ring-1 focus:ring-blue-500"
            />

            <button
              onClick={handleLogin}
              disabled={loading}
              className="col-span-1 md:col-span-1 bg-[#8B1538] text-white rounded-md hover:bg-blue-700 transition disabled:opacity-50"
            >
              {loading ? "Connexion..." : "Valider"}
            </button>
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}
        </div>

        {/* CLIENTS */}
        {clients.length > 0 && (
          <div className="bg-white border rounded-lg p-4">
            <h2 className="text-sm font-medium text-gray-600 mb-3">Clients</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {clients.map((client) => (
                <button
                  key={client.id}
                  onClick={() => setClientSelected(client.id)}
                  className={`px-3 py-2 text-left rounded-md border transition
                    ${
                      clientSelected === client.id
                        ? "bg-blue-50 border-blue-500 text-blue-700"
                        : "bg-gray-50 hover:bg-gray-100"
                    }`}
                >
                  {client.nom || client.nomClient || "Nom non renseigné"}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* CHOIX SECTION */}
        {clientSelected && (
          <div className="bg-white border rounded-lg p-4">
            <h2 className="text-sm font-medium text-gray-600 mb-3">Section</h2>

            <div className="flex gap-2">
              <button
                onClick={() => setSectionSelected("demande")}
                className={`px-4 py-2 rounded-md text-sm font-medium transition
                  ${
                    sectionSelected === "demande"
                      ? "bg-[#8B1538] text-white"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
              >
                Demande
              </button>

              <button
                onClick={() => setSectionSelected("questionnaire")}
                className={`px-4 py-2 rounded-md text-sm font-medium transition
                  ${
                    sectionSelected === "questionnaire"
                      ? "bg-[#8B1538] text-white"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
              >
                Questionnaire
              </button>

              <button
                onClick={() => setSectionSelected("rdv")}
                className={`px-4 py-2 rounded-md text-sm font-medium transition
                  ${
                    sectionSelected === "rdv"
                      ? "bg-[#8B1538] text-white"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
              >
                Rendez-Vous
              </button>
            </div>
          </div>
        )}

        {/* CONTENU */}
        {sectionSelected && (
          <div className="bg-white border rounded-lg p-5">
            {sectionSelected === "demande" && (
              <Demande clientId={clientSelected} />
            )}

            {sectionSelected === "questionnaire" && (
              <Questionnaire clientId={clientSelected} />
            )}

            {sectionSelected === "rdv" && (
              <RendezVous clientId={clientSelected} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyalfaLink;
